import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import WithPush from 'shared/HOCs/WithPush';
import WithUser from 'shared/HOCs/WithUser';

import { openModal } from 'shared/components/Modals/reducer';

import Profile from 'shared/components/Profile';
import {
  Directory,
  Tenders,
  ContentLibrary
} from 'shared/components/Navigation/NavLinks';

import { MOBILE_NAV_CONTENT } from './constants';
import DefaultNavContent from './DefaultNavContent';
import unissuLogo from 'assets/images/logo.svg';

import styles from './styles.module.scss';

class MobileNav extends React.Component {
  state = {
    activeNavContent: MOBILE_NAV_CONTENT.DEFAULT
  };

  redirectTo = (url, extra = []) => {
    this.props.push(url);
    _.map(extra, action => action());
  };

  openAction = (content = 0) => this.setState({ activeNavContent: content });

  closeAction = () =>
    this.setState({ activeNavContent: MOBILE_NAV_CONTENT.DEFAULT });

  render() {
    const { closeNavigation, notificationAlertCount } = this.props;
    const { activeNavContent } = this.state;

    return (
      <div className={styles.mobileNavigationWrapper}>
        <div
          className={classnames(styles.top, {
            [styles.withoutDivider]: _.isEmpty(this.props.user)
          })}>
          <img src={unissuLogo} className={styles.logo} alt="unissu logo" />
          <div
            className={styles.closeNavigation}
            onClick={() => {
              this.closeAction();
              this.props.closeNavigation();
            }}>
            <i className="material-icons">clear</i>
          </div>
        </div>
        <DefaultNavContent
          openAction={this.openAction}
          closeNavigation={closeNavigation}
          redirectToGlobalSearchOrSubmit={
            this.props.redirectToGlobalSearchOrSubmit
          }
          notificationAlertCount={notificationAlertCount}
        />
        <Profile
          notificationAlertCount={notificationAlertCount}
          visible={activeNavContent === MOBILE_NAV_CONTENT.PROFILE}
          closeAction={this.closeAction}
          closeNavigation={closeNavigation}
        />
        <Tenders
          visible={activeNavContent === MOBILE_NAV_CONTENT.TENDERS}
          closeAction={this.closeAction}
          closeNavigation={closeNavigation}
        />
        <Directory
          visible={activeNavContent === MOBILE_NAV_CONTENT.DIRECTORY}
          closeAction={this.closeAction}
          closeNavigation={closeNavigation}
        />
        <ContentLibrary
          visible={activeNavContent === MOBILE_NAV_CONTENT.CONTENT_LIBRARY}
          closeAction={this.closeAction}
          closeNavigation={closeNavigation}
        />
      </div>
    );
  }
}

export default WithPush(
  WithUser(
    connect(
      null,
      { openModal }
    )(MobileNav)
  )
);
